import React from "react";
import "./LargeHeaderTitle.css";

const LargeHeaderTitle = ({
  title = "",
  highlight = "",
}) => (
  <h1 className="large-header-title">
    {title}
    <span className="hero-section-highlight">{highlight}</span>
  </h1>
);

export default LargeHeaderTitle; 